import PropTypes from 'prop-types';

export const ProgressBar = ({ activeStep, classes, components, max, slots, steps, ...props }) => {
  // assign default components
  const LinearProgressContainerComp = components.ProgressBarContainerComp ?? 'div';
  const LinearProgressComp = components.ProgressBarComp ?? 'div';
  // assign default slots
  const ProgressTextSlot = slots.ProgressTextSlot ?? null;
  return (
    <LinearProgressContainerComp {...props} className={classes.progressBarContainer} role='progressbar'>
      <LinearProgressComp
        className={classes.progressBarComp}
        completed={Math.floor(max * ((activeStep + 1) / steps))}
        max={max}
      />
      {ProgressTextSlot && ProgressTextSlot}
    </LinearProgressContainerComp>
  );
};

ProgressBar.defaultProps = {
  activeStep: 0,
  classes: {},
  components: {},
  max: 100,
  slots: {}
};

ProgressBar.propTypes = {
  activeStep: PropTypes.number,
  /** Map of CSS classes to apply to components. */
  // @ts-expect-error
  classes: PropTypes.shape({
    progressBarContainer: PropTypes.string,
    progressBarComp: PropTypes.string
  }),
  completed: PropTypes.number.isRequired,
  /** Optional overrides to default HTML elements used */
  // @ts-expect-error
  components: PropTypes.shape({
    /** Styled or non styled component */
    ProgressBarContainerComp: PropTypes.elementType,
    ProgressBarComp: PropTypes.elementType
  }),
  max: PropTypes.number,
  slots: PropTypes.shape({
    ProgressTextSlot: PropTypes.node
  }),
  steps: PropTypes.number.isRequired
};
